import apiBase from './apiBase';

class PlansApi {
  static get() {
    return apiBase.create().get('/plans');
  }

  static getTenantBikeTypes(tenant) {
    return apiBase.create().get(`/tenants/${encodeURIComponent(tenant)}/bikeTypes`);
  }

  static buy(planId) {
    return apiBase.create().post(`/plans/${planId}/buy`);
  }

  static redeemVoucher(code) {
    return apiBase.create().post('/vouchers/redeem', { code });
  }

  static confirmPlanEndInfo(id) {
    return apiBase.create().post('/plans/confirmEndPlanInfo', { id: id });
  }
}

export default PlansApi;
